export default class StatusMobile {
	constructor({active_event, added_on, company_id, description, id, name, status_id, update_on, zone_required}) {
		this.active_event = active_event || 0;
		this.zone_required = zone_required || 0;
		this.added_on = added_on || "";
		this.company_id = company_id || "";
		this.description = description || "";
		this.id = id || 0;
		this.name = name || "";
		this.status_id = status_id || 0;
		this.update_on = update_on || "";
	}
}
